export enum Status {
  NOT_APPROVED = 'NOT_APPROVED',
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  PEACE = 'PEACE',
  APPROVE_REQ = 'APPROVE_REQ',
  DENIED = 'DENIED',
  DENY_WAITING = 'DENY_WAITING',
}
